import { fetchIndexDocument, useJsonApiWithIndex, type HttpClient, type IndexCollections } from '@jaspr/client-js'
import { useJsonApiWithAtomic, type Operations } from '@jaspr/client-js/atomic'
import type ResourceIndex from './contract'

/** The API's resource collections, typed by the committed contract (spec D74). */
export type Api = IndexCollections<ResourceIndex>

let api: Api | null = null
let atomicHttp: HttpClient | null = null

export async function connectApi(http: HttpClient, indexUrl = '/api/'): Promise<Api> {
    atomicHttp = http
    const index = await fetchIndexDocument<ResourceIndex>(indexUrl, { http })
    return useJsonApiWithIndex(index, { http })
}

export function provideApi(value: Api): void {
    api = value
}

export function useApi(): Api {
    if (api === null) {
        throw new Error('The API has not been connected')
    }
    return api
}

/** A new atomic request (POST /api/operations); one request edits one aggregate (ADR-0013). */
export function useOperations(): Operations<unknown[]> {
    if (atomicHttp === null) {
        throw new Error('The API has not been connected')
    }
    return useJsonApiWithAtomic({ http: atomicHttp, baseUrl: new URL('/api/', window.location.origin).toString() }).operations()
}
